p, hr {
    margin: 0;
    padding: 0;
}

h4 {
    line-height: 30px;
}

.orderContainer {
    position: sticky;
    width: 100%;
    top: 180px;
    left: 855px;
    align-self: flex-start;
}
    
.orderItems {
    overflow-y: auto;
    scrollbar-width: thin;
    width: 100%;
    max-height: calc(64px * 5);
    padding-right: 15px;
    padding-left: 15px;
}

.orderTotal {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 8px;
}

.orderItem {
    padding: 8px 0;
}

.orderItemIcon {
    max-width: 48px;
    height: 48px;
    background-color: #EFEFEF;
    border-radius: 4px;
}

.totalAmount {
    color: var(--PAYONE-BLAU);
}

.checkout-table tr {
    height: 6vh;
}

/* tablets */
@media (min-width: 768px) and (max-width: 991px) {
    .orderContainer {
        display: none;

        /* margin: auto;
        position: static;
        width: 600px;
        max-width: 100%;
        border-radius: 8px;
        margin-bottom: 8px; */
    }
    .checkoutDetails-accordion {
        display: block !important;
    }

    .orderItems,
    .orderTotal {
        max-width: 100%;
    }
    
    p {
        font-size: 18px;
        line-height: 24px;
    }
}

/* smartphones */
@media (max-width: 767px) {
    .orderContainer {
        display: none;

        /* position: static;
        max-width: 100%;
        border-radius: 8px; */
    }

    .checkoutDetails-accordion {
        display: block !important;
    }

    .orderItems {
        max-height: calc(72px * 5);
    }

    .orderItemIcon {
        max-width: 40px;
        max-height: 40px;
    }

    p {
        font-size: 16px;
        line-height: 20px;
    }
}

@media (min-height: 680px) and (max-height: 720px) {
    .orderItems {
        max-height: calc(64px * 4);
    }
}

.chevronIcon {
    color: #f8f9fa;
    transition: transform 0.3s;
  }
  .rotated {
    transform: rotate(180deg);
  }
  .normal {
    transform: rotate(0deg);
  }

  .chevronIcon {
    color: #f8f9fa;
    margin-left: 10px;
    transition: transform 0.3s;
    font-size: 2rem;
    position: relative;
  }